import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51fe7176"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filelist" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Weet u zeker dat u dit bestand wilt verwijderen?", -1))
const _hoisted_6 = { key: 2 }
const _hoisted_7 = {
  key: 0,
  style: { padding: '5px 12px', lineHeight: '28px' }
}
const _hoisted_8 = {
  key: 1,
  style: { padding: '5px 12px', lineHeight: '28px' }
}
const _hoisted_9 = {
  key: 0,
  style: { padding: '5px 12px', lineHeight: '28px' }
}
const _hoisted_10 = {
  key: 1,
  style: { padding: '5px 12px', lineHeight: '28px' }
}
const _hoisted_11 = {
  key: 0,
  style: {"width":"100%"},
  controls: "",
  autoplay: "",
  muted: "",
  ref: "videoPlayer"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 2,
  class: "image-tagger"
}
const _hoisted_15 = { class: "image-container" }
const _hoisted_16 = ["src"]

import { computed, ref, withDefaults } from 'vue'
import axios from 'axios'
import {
  EyeOutlined,
  HighlightOutlined,
  DeleteOutlined,
  CommentOutlined,
  FilePdfOutlined,
  PushpinOutlined,
  PushpinFilled
} from '@ant-design/icons-vue'
import TextEditor from '@/components/TextEditor.vue'
import ImageEditor from '@/components/ImageEditor.vue'
import { notification } from 'ant-design-vue'
import MediaItem, { Tag } from '@/types/mediaItem'
import { surveyStore } from '@/stores/survey'
import MediaLocationTagger from '@/components/imageTagger/MediaLocationTagger.vue'

interface Block {
  id:number,
  name:string,
  media:{
    floorplans: { [key:string]: MediaItem }
    facades: { [key:string]: MediaItem }
  }
}

interface Building {
  id:number,
  number:number,
  media:{
    floorplans: { [key:string]: MediaItem }
    facades: { [key:string]: MediaItem }
  }
}

interface Props {
  media:MediaItem[]
  filter?:{ key:string, value: string|number }|null
  canEdit?: boolean
  canComment?: boolean
  canDelete?: boolean
  canTag?: boolean
  taggingDisabled?: boolean
  block?: Block|null
  building?: Building|null
  answerId?: number|null
  allowedImageTypes?: string[]
  allowedVideoTypes?: string[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Filelist',
  props: {
    media: null,
    filter: { default: null },
    canEdit: { type: Boolean, default: false },
    canComment: { type: Boolean, default: false },
    canDelete: { type: Boolean, default: false },
    canTag: { type: Boolean, default: false },
    taggingDisabled: { type: Boolean, default: false },
    block: { default: null },
    building: { default: null },
    answerId: { default: null },
    allowedImageTypes: { default: () => ['image/jpg', 'image/jpeg', 'image/png'] },
    allowedVideoTypes: { default: () => ['video/mp4', 'video/m4v'] }
  },
  emits: ['imageEdited', 'deleteFile'],
  setup(__props: any, { emit }) {

const props = __props as { media:MediaItem[], filter:{ key:string, value: string|number }|null, canEdit: boolean, canComment: boolean, canDelete: boolean, canTag: boolean, taggingDisabled: boolean, block: Block|null, building: Building|null, answerId: number|null, allowedImageTypes: string[], allowedVideoTypes: string[] };





const showPreviewModal = ref(false)
const showCommentModal = ref(false)
const showEditModal = ref(false)
const saving = ref(false)
const file = ref<MediaItem|null>(null)

const imageTaggerData = ref<{
  visible: boolean,
  model: string|null,
  type: string|null,
  directory: string|null,
  file: MediaItem|null,
  survey_id: number|null,
  survey_answer_id: number|null,
  tagged_media_id: number|null
}>({
  visible: false,
  model: null,
  type: null,
  directory: null,
  file: null,
  survey_id: null,
  survey_answer_id: null,
  tagged_media_id: null
})

const buildingFloorplansAvailable = computed(() => {
  return props.canTag && props.building && Object.keys(props.building.media.floorplans).length
})

const buildingFacadesAvailable = computed(() => {
  return props.canTag && props.building && Object.keys(props.building.media.facades).length
})

const buildingBlockFloorplansAvailable = computed(() => {
  return props.canTag && props.block && Object.keys(props.block.media.floorplans).length
})

const buildingBlockFacadesAvailable = computed(() => {
  return props.canTag && props.block && Object.keys(props.block.media.facades).length
})

function togglePreviewModal (fileToPreview:MediaItem|null = null) : void {
  if (!showPreviewModal.value && fileToPreview) {
    if (fileToPreview.type === 'application/pdf') {
      window.open(fileToPreview.url, '_blank')
    } else {
      file.value = fileToPreview
      showPreviewModal.value = true
    }
  } else {
    file.value = null
    showPreviewModal.value = false
  }
}

function toggleCommentModal (fileToComment:MediaItem|null = null) : void {
  showCommentModal.value = !showCommentModal.value

  if (showCommentModal.value) {
    file.value = fileToComment
  } else {
    file.value = null
  }
}

function storeComment (id:number, note:string) : void {
  saving.value = true
  axios.post(process.env.VUE_APP_API_URL + '/media/' + id + '/comment', { note: note }).then(() => {
    toggleCommentModal()
    notification.success({
      message: 'Opmerking opgeslagen.',
      description: 'Uw opmerking bij de foto is succesvol opgeslagen.',
      duration: 5
    })
  }).finally(() => {
    saving.value = false
  })
}

function toggleEditModal (fileToEdit:MediaItem|null = null) : void {
  showEditModal.value = !showEditModal.value

  if (showEditModal.value) {
    file.value = fileToEdit
  } else {
    file.value = null
  }
}

function imageEdited (data:{ file:File, mediaId:number }) : void {
  emit('imageEdited', data)
  toggleEditModal()
}

function deleteFile (file:MediaItem) : void {
  emit('deleteFile', file)
}

function downloadFile (mediaItem:MediaItem) : void {
  axios.get(process.env.VUE_APP_API_URL + '/media/' + mediaItem.id + '/download', { responseType: 'arraybuffer' }).then(r => {
    const blob = new Blob([r.data], { type: mediaItem.type })
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = mediaItem.name
    link.click()
  })
}

function showImageTagger (model:string, type:string, directory:string, file:MediaItem, surveyId:number, surveyAnswerId:number, mediaId:number) : void {
  imageTaggerData.value = {
    visible: true,
    model: model,
    type: type,
    directory: directory,
    file: file,
    survey_id: surveyId,
    survey_answer_id: surveyAnswerId,
    tagged_media_id: mediaId
  }
}

function hideImageTagger (file:MediaItem) : void {
  if (imageTaggerData.value.model && imageTaggerData.value.directory && imageTaggerData.value.type) {
    surveyStore().survey[imageTaggerData.value.model].media[imageTaggerData.value.type][imageTaggerData.value.directory] = file
    imageTaggerData.value = {
      visible: false,
      model: null,
      type: null,
      directory: null,
      file: null,
      survey_id: null,
      survey_answer_id: null,
      tagged_media_id: null
    }
  }
}

function getVideoUrl (file: File|MediaItem): string {
  if (file instanceof File) return URL.createObjectURL(file)
  else return file.url
}

function isImage (file: File): boolean {
  return props.allowedImageTypes.includes(file.type)
}

function isVideo (file: File): boolean {
  return props.allowedVideoTypes.includes(file.type)
}

function getTagClass (tag:Tag) : string {
  if (tag.tagged_issue_id) {
    return tag.tagged_issue?.closed ? 'issue solved' : 'issue'
  } else if (tag.tagged_media_id) {
    return 'media'
  }

  return ''
}

function getLevelName (levelDirectory:string) : string {
  const level = parseInt(levelDirectory.replace('floorplanLevel', ''))
  if (level === 0) {
    return 'Begane grond'
  } else if (level === 90) {
    return 'Buiten'
  } else if (level === 99) {
    return 'Dak'
  } else if (level > 0) {
    return level + 'e verdieping'
  } else {
    return 'Verdieping -' + level
  }
}

function getFacadeName (facadeDirectory:string) : string {
  const facade = facadeDirectory.replace('Facade', '')
  if (facade === 'front') {
    return 'Voorgevel'
  } else if (facade === 'rear') {
    return 'Achtergevel'
  } else if (facade === 'left') {
    return 'Linker gevel'
  } else {
    return 'Rechter gevel'
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_list_item_meta = _resolveComponent("a-list-item-meta")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_list, {
      "item-layout": "horizontal",
      "data-source": __props.media,
      size: "small"
    }, {
      renderItem: _withCtx(({ item }) => [
        _createVNode(_component_a_list_item, null, {
          actions: _withCtx(() => [
            _createElementVNode("span", null, [
              _createVNode(_component_a_button, {
                onClick: ($event: any) => (togglePreviewModal(item))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(EyeOutlined))
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            (__props.canEdit && item.type !== 'application/pdf')
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                  _createVNode(_component_a_button, {
                    onClick: ($event: any) => (toggleEditModal(item))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(HighlightOutlined))
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]))
              : _createCommentVNode("", true),
            (__props.canDelete)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  _createVNode(_component_a_popconfirm, {
                    placement: "topRight",
                    "ok-text": "Ja",
                    "cancel-text": "Nee",
                    onConfirm: ($event: any) => (deleteFile(item))
                  }, {
                    title: _withCtx(() => [
                      _hoisted_5
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(DeleteOutlined))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"])
                ]))
              : _createCommentVNode("", true),
            (__props.canComment)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                  _createVNode(_component_a_button, {
                    onClick: ($event: any) => (toggleCommentModal(item))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(CommentOutlined))
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]))
              : _createCommentVNode("", true),
            (props.building && (_unref(buildingFloorplansAvailable) || _unref(buildingFacadesAvailable)))
              ? (_openBlock(), _createBlock(_component_a_dropdown, {
                  key: 3,
                  trigger: ['click']
                }, {
                  overlay: _withCtx(() => [
                    _createVNode(_component_a_menu, null, {
                      default: _withCtx(() => [
                        (_unref(buildingFloorplansAvailable))
                          ? (_openBlock(), _createElementBlock("b", _hoisted_7, "Plattegronden (Bouwnummer)"))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(props.building.media.floorplans), (floorplanKey) => {
                          return (_openBlock(), _createBlock(_component_a_menu_item, {
                            key: floorplanKey,
                            onClick: ($event: any) => (showImageTagger('building', 'floorplans', floorplanKey, props.building.media.floorplans[floorplanKey], _unref(surveyStore)().survey.id, props.answerId, item.id))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(getLevelName(floorplanKey)) + " ", 1),
                              (props.building.media.floorplans[floorplanKey].tags.some((tag) => tag.tagged_media_id === item.id))
                                ? (_openBlock(), _createBlock(_unref(PushpinFilled), {
                                    key: 0,
                                    style: { color: '#f38929' }
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        }), 128)),
                        (_unref(buildingFacadesAvailable))
                          ? (_openBlock(), _createElementBlock("b", _hoisted_8, "Gevelaanzichten (Bouwnummer)"))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(props.building.media.facades), (facadeKey) => {
                          return (_openBlock(), _createBlock(_component_a_menu_item, {
                            key: facadeKey,
                            onClick: ($event: any) => (showImageTagger('building', 'facades', facadeKey, props.building.media.facades[facadeKey], _unref(surveyStore)().survey.id, props.answerId, item.id))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(getFacadeName(facadeKey)) + " ", 1),
                              (props.building.media.facades[facadeKey].tags.some((tag) => tag.tagged_media_id === item.id))
                                ? (_openBlock(), _createBlock(_unref(PushpinFilled), {
                                    key: 0,
                                    style: { color: '#f38929' }
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, { style: {"margin-right":"4px"} }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(PushpinOutlined))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1024))
              : (!props.building && props.block && (_unref(buildingBlockFloorplansAvailable) || _unref(buildingBlockFacadesAvailable)))
                ? (_openBlock(), _createBlock(_component_a_dropdown, {
                    key: 4,
                    trigger: ['click']
                  }, {
                    overlay: _withCtx(() => [
                      _createVNode(_component_a_menu, null, {
                        default: _withCtx(() => [
                          (_unref(buildingBlockFloorplansAvailable))
                            ? (_openBlock(), _createElementBlock("b", _hoisted_9, "Plattegronden (Blok)"))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(props.block.media.floorplans), (floorplanKey) => {
                            return (_openBlock(), _createBlock(_component_a_menu_item, {
                              key: floorplanKey,
                              onClick: ($event: any) => (showImageTagger('building_block', 'floorplans', floorplanKey, props.block.media.floorplans[floorplanKey], _unref(surveyStore)().survey.id, props.answerId, item.id))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(getLevelName(floorplanKey)) + " ", 1),
                                (props.block.media.floorplans[floorplanKey].tags.some((tag) => tag.tagged_media_id === item.id))
                                  ? (_openBlock(), _createBlock(_unref(PushpinFilled), {
                                      key: 0,
                                      style: { color: '#f38929' }
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          }), 128)),
                          (_unref(buildingBlockFacadesAvailable))
                            ? (_openBlock(), _createElementBlock("b", _hoisted_10, "Gevelaanzichten (Blok)"))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(props.block.media.facades), (facadeKey) => {
                            return (_openBlock(), _createBlock(_component_a_menu_item, {
                              key: facadeKey,
                              onClick: ($event: any) => (showImageTagger('building_block', 'facades', facadeKey, props.block.media.facades[facadeKey], _unref(surveyStore)().survey.id, props.answerId, item.id))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(getFacadeName(facadeKey)) + " ", 1),
                                (props.block.media.facades[facadeKey].tags.some((tag) => tag.tagged_media_id === item.id))
                                  ? (_openBlock(), _createBlock(_unref(PushpinFilled), {
                                      key: 0,
                                      style: { color: '#f38929' }
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, { style: {"margin-right":"4px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(PushpinOutlined))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_list_item_meta, {
              class: "clickable",
              description: item.date,
              style: {"font-weight":"500"}
            }, {
              avatar: _withCtx(() => [
                (item.type === 'application/pdf')
                  ? (_openBlock(), _createBlock(_component_a_avatar, {
                      key: 0,
                      class: "clickable",
                      shape: "square",
                      size: 48,
                      style: _normalizeStyle([{ backgroundColor: '#f38929' }, {"font-size":"18px"}]),
                      onClick: ($event: any) => (togglePreviewModal(item))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(FilePdfOutlined))
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : (_openBlock(), _createBlock(_component_a_avatar, {
                      key: 1,
                      class: "clickable",
                      shape: "square",
                      size: 48,
                      src: item.url,
                      onClick: ($event: any) => (togglePreviewModal(item))
                    }, null, 8, ["src", "onClick"]))
              ]),
              title: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.file_name || item.name || 'Bestand'), 1)
              ]),
              description: _withCtx(() => [
                (item.note)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      innerHTML: item.note
                    }, null, 8, _hoisted_2))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["description"])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["data-source"]),
    (file.value)
      ? (_openBlock(), _createBlock(_component_a_modal, {
          key: 0,
          title: file.value.file_name || file.value.name,
          width: 600,
          footer: null,
          visible: showPreviewModal.value,
          "body-style": { padding: 0 },
          onCancel: togglePreviewModal
        }, {
          default: _withCtx(() => [
            (isVideo(file.value))
              ? (_openBlock(), _createElementBlock("video", _hoisted_11, [
                  _createElementVNode("source", {
                    src: getVideoUrl(file.value),
                    type: "video/mp4"
                  }, null, 8, _hoisted_12)
                ], 512))
              : _createCommentVNode("", true),
            (isImage(file.value) && !(file.value.tags?.length ?? 0))
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: file.value.url,
                  style: {"width":"100%"}
                }, null, 8, _hoisted_13))
              : (isImage(file.value) && (file.value.tags?.length ?? 0) > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createVNode(_component_a_row, { gutter: [16,16] }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("img", {
                                src: file.value.url
                              }, null, 8, _hoisted_16),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(file.value.tags, (tag, index) => {
                                return (_openBlock(), _createBlock(_component_a_tooltip, {
                                  placement: "top",
                                  key: index,
                                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                                }, _createSlots({
                                  default: _withCtx(() => [
                                    (!props.filter || tag[props.filter.key] === props.filter.value)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: _normalizeClass(["tag", getTagClass(tag)]),
                                          style: _normalizeStyle({ left: `calc(${tag.position.x}%)`, top: `calc(${tag.position.y}%)` })
                                        }, null, 6))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, [
                                  (tag.tagged_issue_id)
                                    ? {
                                        name: "title",
                                        fn: _withCtx(() => [
                                          _createTextVNode(" Servicemelding #" + _toDisplayString(tag.tagged_issue_id) + " ", 1),
                                          (tag.tagged_issue?.closed)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createTextVNode("- Opgelost")
                                              ], 64))
                                            : _createCommentVNode("", true)
                                        ]),
                                        key: "0"
                                      }
                                    : (tag.tagged_media_id)
                                      ? {
                                          name: "title",
                                          fn: _withCtx(() => [
                                            _createTextVNode("Bewijslastkeuring #" + _toDisplayString(tag.survey_id), 1)
                                          ]),
                                          key: "1"
                                        }
                                      : {
                                          name: "title",
                                          fn: _withCtx(() => [
                                            _createTextVNode("Onbekende tag")
                                          ]),
                                          key: "2"
                                        }
                                ]), 1024))
                              }), 128))
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["title", "visible"]))
      : _createCommentVNode("", true),
    (file.value)
      ? (_openBlock(), _createBlock(_component_a_modal, {
          key: 1,
          title: file.value.file_name || file.value.name,
          visible: showCommentModal.value,
          onCancel: toggleCommentModal
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_a_button, { onClick: toggleCommentModal }, {
              default: _withCtx(() => [
                _createTextVNode("Annuleren")
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, {
              type: "primary",
              loading: saving.value,
              disabled: saving.value,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (storeComment(file.value.id, file.value.note)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Opslaan")
              ]),
              _: 1
            }, 8, ["loading", "disabled"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(TextEditor, {
                      content: file.value.note,
                      onContentChange: _cache[1] || (_cache[1] = ($event: any) => (file.value.note = $event))
                    }, null, 8, ["content"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["title", "visible"]))
      : _createCommentVNode("", true),
    (file.value)
      ? (_openBlock(), _createBlock(_component_a_modal, {
          key: 2,
          title: file.value.file_name || file.value.name,
          visible: showEditModal.value,
          "body-style": { padding: 0 },
          footer: null,
          onCancel: toggleEditModal
        }, {
          default: _withCtx(() => [
            _createVNode(ImageEditor, {
              mediaItem: file.value,
              onImageEdited: _cache[3] || (_cache[3] = ($event: any) => (imageEdited($event)))
            }, null, 8, ["mediaItem"])
          ]),
          _: 1
        }, 8, ["title", "visible"]))
      : _createCommentVNode("", true),
    (imageTaggerData.value.file)
      ? (_openBlock(), _createBlock(MediaLocationTagger, {
          key: 3,
          "survey-id": imageTaggerData.value.survey_id,
          "tagged-media-id": imageTaggerData.value.tagged_media_id,
          visible: imageTaggerData.value.visible,
          disabled: props.taggingDisabled,
          file: imageTaggerData.value.file,
          "survey-answer-id": imageTaggerData.value.survey_answer_id,
          onCloseTagger: _cache[4] || (_cache[4] = ($event: any) => (hideImageTagger($event)))
        }, null, 8, ["survey-id", "tagged-media-id", "visible", "disabled", "file", "survey-answer-id"]))
      : _createCommentVNode("", true)
  ]))
}
}

})